import { DrEntity } from './dr-entity';
import { DrObject, DrObjectType } from './dr-object';
import { isUndefined } from './utils';
import { AbstractControl, UntypedFormGroup, UntypedFormArray, UntypedFormControl } from '@angular/forms';
import * as _ from 'underscore';
import { SearchType } from './enums';

export class WorkflowStep extends DrEntity {
    attributes: any[];
    comment: string;
    description: string;
    expandFields: boolean;
    handle: string;
    includeFamilyMembers: boolean;
    includeSynonyms: boolean;
    isDateQuery: boolean;
    maxCommentLength: number;
    orderOfExecution: number;
    query: string;
    reportRequests: any[];
    responseHandle: string;
    type: string; // TODO type this
    searchType: SearchType;
    percentComplete: number;
    viewType: SearchType;
    numberResults: number;
    task: string;
    archived: boolean;
    errorMessage: string;
    isWarning?: boolean;

    constructor(value?: Partial<WorkflowStep>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }

    getForm(): AbstractControl {
        return new UntypedFormGroup({
            query: new UntypedFormControl(this.query),
            comment: new UntypedFormControl(this.comment),
            description: new UntypedFormControl(this.description),
            includeFamilyMembers: new UntypedFormControl(this.includeFamilyMembers),
            expandFields: new UntypedFormControl(this.expandFields),
            includeSynonyms: new UntypedFormControl(this.includeSynonyms),
            searchType: new UntypedFormControl(this.searchType),
            isDateQuery: new UntypedFormControl(this.isDateQuery),
            errorMessage: new UntypedFormControl(this.errorMessage),
            reportRequests: new UntypedFormControl(this.reportRequests)
        });
    }
}

export class WorkflowViewModel extends DrObject {
    model: Partial<Workflow>;
    constructor(value?: Partial<Workflow>) {
        super(DrObjectType.WORK_FLOWS);
        if (value) {
            this.model = value;
        }
    }
}

export class Workflow extends DrEntity {
    createdBy: string;
    createdOn: string;
    culledResults: number;
    dataSetItem: Record<string, unknown>;
    description: string;
    folderItem: any;
    lastExecutedBy: string;
    lastExecutedOn: any;
    lockedBy: string;
    modifiedBy: string;
    modifiedOn: any;
    name: string;
    projectHandle: string;
    queryItems: any;
    resultSet: any;
    resultCount: number;
    sourceViewHandle: string;
    tagItem: any;
    taskHandle: string;
    version: number;
    archived: boolean;
    hasRunError: boolean;

    data: Workflow;
    // grid attributes
    isParent: boolean;
    isChild: boolean;
    isWorkflowSettingsStep?: boolean;
    isExpanded = false;
    parent: Workflow;
    children = new Array<Workflow>();

    constructor(value?: Partial<Workflow>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
        if (isUndefined(this.archived)) {
            this.archived = false;
        }
        if (isUndefined(this.queryItems)) {
            this.queryItems = { items: [WorkflowStep] };
        }

        this.parent = null;

        const attr = _.find(this.attributes, (attribute) => attribute.name === 'isRunning');
        const isRunning = attr?.value === 'true';
        this.hasRunError = this.queryItems?.items?.filter(it => (it.responseHandle === null || isUndefined(it.responseHandle)) && !isUndefined(this.lastExecutedOn))?.length > 0 && !isRunning;
        if (!this.resultCount && this.attributes) {
            const resultCount = this.attributes.find(a => a.name === 'resultcount');
            if (resultCount) {
                this.resultCount = parseInt(resultCount.value, 10);
            }
        }
    }

    getForm(): AbstractControl {
        return new UntypedFormGroup({
            queryItems: new UntypedFormArray(_.map(this.queryItems.items, (item) => item.getForm())),
            dataSetItem: new UntypedFormGroup({
                attributes: new UntypedFormControl(this.dataSetItem ? this.dataSetItem.attributes : null),
                description: new UntypedFormControl(this.dataSetItem ? this.dataSetItem.description : null),
                handle: new UntypedFormControl(this.dataSetItem ? this.dataSetItem.handle : null),
                name: new UntypedFormControl(this.dataSetItem ? this.dataSetItem.name : null),
                type: new UntypedFormControl(this.dataSetItem ? this.dataSetItem.type : null),
                errorMessage: new UntypedFormControl(this.dataSetItem ? this.dataSetItem.errorMessage : null)
            })
        });
    }

    static fromWorkflowStep(value: Partial<Workflow>, parent?: Workflow): Workflow {
        if (value) {
            const workflowStep = new Workflow(value);
            const workflow = new Workflow();
            Object.assign(workflow, workflowStep);
            workflowStep.isChild = true;
            workflowStep.isWorkflowSettingsStep = true;
            workflowStep.name = value.attributes?.[0]?.value || '';

            if (parent) {
                parent.children = parent.children || [];
                workflowStep.parent = parent;
                parent.children.push(workflowStep);
            }
            return workflowStep;
        }
        return null;
    }
}
